import { Component } from '@angular/core';
import { NavController,ViewController, ModalController } from 'ionic-angular';
import { LoadingProvider } from '../../providers/loading/loading';
import { ConfigProvider } from '../../providers/config/config';
import { Http } from '@angular/http';
import { SharedDataProvider } from '../../providers/shared-data/shared-data';
import { Camera, CameraOptions } from '@ionic-native/camera';
import { Platform } from 'ionic-angular';
import { LoginPage } from '../login/login';
import swal from 'sweetalert';
import { HomePage } from '../home/home';
import { CreateSubAccountsPage } from '../create-subaccount/create-subaccount';

@Component({
  selector: 'page-subaccount',
  templateUrl: 'subaccount.html',
})
export class SubAccountsPage {
  httpRunning = true;
    subaccounts = new Array;
  formData = {
    company_id:'',
    customers_companyname:'',
    customers_gassafe:'',
    customers_preferedboiler:'',
    customers_firstname: '',
    customers_lastname: '',
    subaccount_email_address: '',
    subaccount_password: '',
    customers_telephone: '',
    customers_picture: '',
    brand:'',
    traderID:'',
    phoenix_email:'',
    is_subscribed:'',
    free_trial_end:'',
    self_surveyURL:'',
    isApproved:'',
  };
  image;
  errorMessage = '';
  constructor(
    public http: Http,
    public navCtrl: NavController,
    public config: ConfigProvider,
    public viewCtrl: ViewController,
    public modalCtrl: ModalController,
    public loading: LoadingProvider,
    public shared: SharedDataProvider,
    public platform: Platform,
    private camera: Camera
  ) {
  }

  ionViewDidEnter() {
    this.getSubAccounts();
    console.log("Customer info:",this.shared.customerData);
    this.formData.company_id = this.shared.customerData.customers_id;
    this.formData.customers_companyname = this.shared.customerData.companyname;
    this.formData.traderID = this.shared.customerData.traderID;
    this.formData.phoenix_email = this.shared.customerData.phoenix_email;
    this.formData.brand = this.shared.customerData.brand;
    this.formData.is_subscribed = this.shared.customerData.is_subscribed;
    this.formData.free_trial_end = this.shared.customerData.free_trial_end;
    this.formData.self_surveyURL = this.shared.customerData.self_surveyURL;
    this.formData.isApproved = this.shared.customerData.isApproved;
    console.log("You are allowed subaccounts:",this.shared.customerData.no_ofsubaccounts);
}


  deactivate(account_id){
    console.log("Deactivate ID:",account_id);
    console.log("Master ID:",this.shared.customerData.customers_id);
    var data: { [k: string]: any } = {};
    data.master_id = this.shared.customerData.customers_id;
    data.sub_id = account_id;
    data.active = 0;
    this.http.post(this.config.url + 'setActive', data).map(res => res.json()).subscribe(data => {
      this.loading.hide();
      this.httpRunning = false;
      //$rootScope.address=response.data.data;
      if (data.success == 1) {
        console.log("Deactivated");
        this.getSubAccounts();
      }
      // $scope.$broadcast('scroll.refreshComplete');
    },
      function (response) {
        this.loading.hide();
        this.alert.show("Server Error while Loading Orders");
        //console.log(response);
      });
  }

  activate(account_id){
    console.log("Deactivate ID:",account_id);
    console.log("Master ID:",this.shared.customerData.customers_id);
    var data: { [k: string]: any } = {};
    data.master_id = this.shared.customerData.customers_id;
    data.sub_id = account_id;
    data.active = 1;
    this.http.post(this.config.url + 'setActive', data).map(res => res.json()).subscribe(data => {
      this.loading.hide();
      this.httpRunning = false;
      //$rootScope.address=response.data.data;
      if (data.success == 1) {
        console.log("Deactivated");
        this.getSubAccounts();
      }
      // $scope.$broadcast('scroll.refreshComplete');
    },
      function (response) {
        this.loading.hide();
        this.alert.show("Server Error while Loading Orders");
        //console.log(response);
      });
  }

  createSub(){
    console.log("We have this many subaccounts",this.subaccounts.length);
    console.log("You are allowed this many:",this.shared.customerData.no_ofsubaccounts);
    if(this.subaccounts.length >= this.shared.customerData.no_ofsubaccounts){
      swal({title: "Sorry!",text: "Your have reached your account limit",icon: "error"}).then((value) => {
          //this.navCtrl.push(HomePage);

          this.viewCtrl.dismiss();
          //this.shared.login(data.data[0]);
      });
    }
    else{
    this.navCtrl.push(CreateSubAccountsPage);
    }
  }

  getSubAccounts() {
    this.httpRunning = true;
    this.subaccounts = [];

    this.loading.show();
    var data: { [k: string]: any } = {};
    data.ar_id = this.shared.customerData.customers_id;
    this.http.post(this.config.url + 'getSubUsers', data).map(res => res.json()).subscribe(data => {
      this.loading.hide();
      this.httpRunning = false;
      //$rootScope.address=response.data.data;
      if (data.success == 1) {
        console.log("SubAccounts:",data.data);
        this.subaccounts = data.data;
      }
      // $scope.$broadcast('scroll.refreshComplete');
    },
      function (response) {
        this.loading.hide();
        this.alert.show("Server Error while Loading Orders");
        //console.log(response);
      });
  };

  openCamera() {
    const options: CameraOptions = {
      quality: 80,
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
      allowEdit: true,
      targetWidth: 100,
      targetHeight: 100,
      saveToPhotoAlbum: false,
      correctOrientation: true
    }
    this.platform.ready().then(() => {


      this.camera.getPicture(options).then((imageData) => {
        // imageData is either a base64 encoded string or a file URI
        // If it's base64:
        this.image = 'data:image/jpeg;base64,' + imageData;
        // console.log(base64Image);

      }, (err) => { });
    });
  }
  signUp() {
    this.loading.show();
    this.errorMessage = '';
    this.formData.customers_picture = this.image;
    this.formData.brand = '2';
    this.http.post(this.config.url + 'processRegistrationSub', this.formData).map(res => res.json()).subscribe(data => {

      this.loading.hide();
      console.log("Registration Object:",data.success);


      if (data.success == '1') {

        console.log("Success:",data.data[0]);

        swal({title: "Success!",text: "Your Sub account has been created",icon: "success"}).then((value) => {
            //this.navCtrl.push(HomePage);

            this.viewCtrl.dismiss();
            //this.shared.login(data.data[0]);
        });



      }
      if (data.success == 0) {
        swal({title: "Opps...",text: "Something went wrong!",icon: "error"}).then((value) => {
            //this.navCtrl.push(HomePage);
            //this.navCtrl.popToRoot()
        });
      }
    });
  }

  openPrivacyPolicyPage() {
    let modal = this.modalCtrl.create('PrivacyPolicyPage');
    modal.present();
  }
  openTermServicesPage() {
    let modal = this.modalCtrl.create('TermServicesPage');
    modal.present();
  }
  openRefundPolicyPage() {
    let modal = this.modalCtrl.create('RefundPolicyPage');
    modal.present();
  }
  dismiss() {
    this.viewCtrl.dismiss();
    let modal = this.modalCtrl.create(LoginPage);
    modal.present();
  }
  // ionViewDidLoad() {
  //   console.log('ionViewDidLoad SignUpPage');
  // }
}



// WEBPACK FOOTER //
// ./src/pages/subaccount/subaccount.ts